import { TableRow } from "@mui/material";

import { StyledTableHeadingCell } from "../../../../../common/components/functional/simpleTable/styled";
import { PayslipTotals } from "../../../../salaries/payslips/payslipAPI";

interface Props {
  totals: PayslipTotals;
}

export const PayslipTotalsRow = ({ totals }: Props) => {
  return (
    <TableRow>
      <StyledTableHeadingCell />
      <StyledTableHeadingCell />
      <StyledTableHeadingCell />
      <StyledTableHeadingCell />
      <StyledTableHeadingCell />
      <StyledTableHeadingCell />
      <StyledTableHeadingCell />
      <StyledTableHeadingCell />
      <StyledTableHeadingCell />
      <StyledTableHeadingCell>{totals.fringeBenefits}</StyledTableHeadingCell>
      <StyledTableHeadingCell>
        {totals.employerHealthInsurance}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell>{totals.taxable}</StyledTableHeadingCell>
      <StyledTableHeadingCell>{totals.incomeGross}</StyledTableHeadingCell>
      <StyledTableHeadingCell>{totals.taxWithholding}</StyledTableHeadingCell>
      <StyledTableHeadingCell>{totals.pensionInsurance}</StyledTableHeadingCell>
      <StyledTableHeadingCell>
        {totals.unemploymentInsurance}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell>{totals.taxExempt}</StyledTableHeadingCell>
      <StyledTableHeadingCell>{totals.incomeNet}</StyledTableHeadingCell>
      <StyledTableHeadingCell />
    </TableRow>
  );
};
